import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { GetPlayerCurrentPastEvents } from "../../Config/API/events";
import useVariables from "../hooks/useVariables";
import SidebarEventCard from "../SidebarEventCard";
import { Link } from "react-router-dom";

const CurrentEvents = () => {
  const { PID } = useVariables();
  const [data, setData] = useState([]);

  const fetchEvents = async () => {
    const response = await GetPlayerCurrentPastEvents(PID, "current");
    const res = await response.json();

    if (res?.type === "success") {
      const filter = res?.result?.filter((e) => !e?.complete);
      if (filter?.length > 3) filter.length = 3;
      setData(filter);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <Row className="sideItem" style={{ background: "transparent", boxShadow: "none" }}>
      <Col span={24}>
        <h1 className="timelineAboutpadding d-md-none">Current Events</h1>
      </Col>
      {data.map((item) => {
        return <SidebarEventCard key={item._id} data={item} />;
      })}
      <Link to={"/player/search"} className="show-more">
        Show More
      </Link>
    </Row>
  );
};

export default CurrentEvents;
